import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor() { }

  getWorker(){
    return JSON.parse(localStorage.getItem("users"));
  }

  onlineUser(){
    return JSON.parse(localStorage.getItem("loginUser"));
  }
  public reci=new BehaviorSubject({})
  public rec(item){
this.reci.next(item)
  }

  public dataSource = new BehaviorSubject([]);

    public updateSource(message){
    this.dataSource.next(message);
  }

  public showpro=new BehaviorSubject(false)
  public show(item){
    this.showpro.next(item)
  }
}
